import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FinancialSummaryModeService {

  private messageSource = new BehaviorSubject(JSON.stringify(null));
  currentMessage: Observable<string> = this.messageSource.asObservable();
  
  constructor() { }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  getMessage() {
    take(1);
    return this.currentMessage;
  }

  async getId() {
    take(1);
    return this.currentMessage;
  }
}